var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"general-modal-wrapper"},[_c('div',{staticClass:"general-modal-content-wrapper"},[_c('div',{staticClass:"general-modal-close-icon",on:{"click":_vm.onClose}},[_c('b-icon',{attrs:{"icon":"x-lg"}})],1),_c('div',{staticClass:"general-modal-content"},[_c('div',{staticClass:"general-modal-body"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }